<template>
    <div class="drop-down-show-info">
        <button
            class="title-wrapper"
            @click="$el.classList.toggle('open')"
        >
            <div
                :style="bgColor"
                class="icon-wrapper"
            >
                <i class="fa fa-chevron-down" />
            </div>
            <p class="title">{{ title }}</p>
        </button>
        <div class="content-wrapper">
            <div class="content-container" v-html="content" />
        </div>
    </div>
</template>

<script>
    import { getViewData } from 'assets/js/modules/view-data';

    export default {
        name: 'drop-down-show-info',

        props: {
            title: {
                type: String,
                default: '',
            },
            content: {
                type: String,
                default: '',
            },
            showContent: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * Get the accent color.
             *
             * @returns {string}
             */
            bgColor() {
                return `background-color: #${ getViewData('accent_color') }`;
            },
        },
    };
</script>

<style lang="less" scoped>
    .drop-down-show-info {
        border: 1px solid #dddddd;
        margin-bottom: 10px;
        overflow: hidden;

        p {
            color: #000000;
            font-size: 15px;
            font-weight: 400;
            line-height: 148%;
        }

        .title-wrapper {
            align-items: center;
            background-color: #f5f5f5;
            border: none;
            cursor: pointer;
            display: flex;
            min-height: 36px;
            padding: 0;
            position: relative;
            width: 100%;

            .icon-wrapper {
                align-items: center;
                color: #ffffff;
                display: flex;
                height: 100%;
                justify-content: center;
                position: absolute;
                width: 36px;

                .fa {
                    font-size: 24px;
                }
            }

            .title {
                margin-bottom: 0;
                margin-left: 44px;
                margin-right: 8px;
                text-align: left;
            }
        }

        .content-wrapper {
            max-height: 0;
            overflow: hidden;

            transition:
                max-height 0.3s ease;
        }

        .content-container {
            padding: 10px;
        }

        &.open {
            .content-wrapper {
                border-top: 1px solid #dddddd;
                margin-top: 0;
                max-height: 500px;

                transition:
                    max-height 0.3s ease,
                    border-top 0s linear;
            }
        }

        .content-wrapper {
            color: #000000;
            font-size: 15px;
            font-weight: 400;
            height: auto;
            line-height: 148%;

            ::v-deep {
                p, ul, ol {
                    margin-bottom: 0;
                }

                ul, ol {
                    padding-left: 20px;
                }
            }
        }
    }
</style>
